import { useEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Marca from '../common/Marca';

const MENU = [
  {
    grupo: 'Acompanhamento',
    itens: [
      { to: '/dashboard', icone: 'bi-grid-1x2', label: 'Visão geral' },
      { to: '/protocolos', icone: 'bi-cash-stack', label: 'Por protocolo' },
      { to: '/guias', icone: 'bi-list-ol', label: 'Por guia' },
      { to: '/titulos', icone: 'bi-receipt', label: 'Títulos a lançar' },
      { to: '/arquivos', icone: 'bi-file-earmark-text', label: 'Arquivos' },
      { to: '/saldo', icone: 'bi-wallet2', label: 'Saldo a receber' },
      { to: '/agenda', icone: 'bi-calendar3', label: 'Agenda de envios' },
    ],
  },
  {
    grupo: 'Conferência',
    itens: [
      { to: '/pendencias', icone: 'bi-exclamation-triangle', label: 'Pendências' },
      { to: '/divergencias', icone: 'bi-arrow-left-right', label: 'Divergências' },
      { to: '/glosas', icone: 'bi-scissors', label: 'Glosas' },
      {
        to: '/glosas/auditoria',
        icone: 'bi-clipboard-check',
        label: 'Auditoria de glosa',
      },
      {
        to: '/recuperacoes',
        icone: 'bi-arrow-counterclockwise',
        label: 'Recuperação de glosa',
      },
    ],
  },
  {
    grupo: 'Lançamento',
    itens: [
      { to: '/arquivos/novo', icone: 'bi-upload', label: 'Lançar recebimento' },
      { to: '/modelos', icone: 'bi-diagram-3', label: 'Modelos de arquivo' },
    ],
  },
  {
    grupo: 'Ajuda',
    itens: [{ to: '/documentacao', icone: 'bi-book', label: 'Documentação' }],
  },
];

export default function AppLayout({ children }) {
  const { usuario, sair, isAdmin, isGestor } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [aberta, setAberta] = useState(false);

  // Navegar fecha o menu no celular — senão ele cobre a página nova.
  useEffect(() => setAberta(false), [pathname]);

  const logout = () => {
    sair();
    navigate('/login');
  };

  return (
    <div className="ff-app">
      <div
        className={`ff-backdrop${aberta ? ' visivel' : ''}`}
        onClick={() => setAberta(false)}
        aria-hidden="true"
      />

      <aside className={`ff-sidebar${aberta ? ' aberta' : ''}`}>
        <div className="ff-brand">
          <Marca tamanho={28} />
          FluxFin
        </div>

        <div className="ff-sidebar__nav-area">
          <nav className="ff-nav" aria-label="Navegação principal">
          {MENU.map((secao) => (
            <div key={secao.grupo}>
              <div className="ff-nav__grupo">{secao.grupo}</div>
              {secao.itens.map((m) => (
                <NavLink
                  key={m.to}
                  to={m.to}
                  end={m.to === '/arquivos'}
                  className={({ isActive }) => `ff-link${isActive ? ' ativo' : ''}`}
                >
                  <i className={`bi ${m.icone}`} aria-hidden="true" />
                  {m.label}
                </NavLink>
              ))}
            </div>
          ))}

            {isGestor && (
              <div>
                <div className="ff-nav__grupo">Administração</div>
                <NavLink
                  to="/usuarios"
                  className={({ isActive }) => `ff-link${isActive ? ' ativo' : ''}`}
                >
                  <i className="bi bi-people" aria-hidden="true" />
                  Usuários
                </NavLink>
                {/* O admin ve a trilha inteira; o gestor, so as proprias
                    acoes. O recorte e feito no servidor — esconder o item do
                    menu nunca foi, sozinho, um controle de acesso. */}
                <NavLink
                  to="/auditoria"
                  className={({ isActive }) => `ff-link${isActive ? ' ativo' : ''}`}
                >
                  <i className="bi bi-clipboard-check" aria-hidden="true" />
                  {isAdmin ? 'Auditoria' : 'Minhas ações'}
                </NavLink>
                {/* Manutencao da base: apaga tudo e recarrega as seeds. So
                    admin ve, e so admin passa no servidor — o item escondido
                    nunca foi, sozinho, um controle de acesso. */}
                {isAdmin && (
                  <NavLink
                    to="/controles"
                    className={({ isActive }) => `ff-link${isActive ? ' ativo' : ''}`}
                  >
                    <i className="bi bi-sliders" aria-hidden="true" />
                    Controles
                  </NavLink>
                )}
              </div>
            )}
          </nav>
        </div>

        <div className="ff-sidebar__rodape">
          <div className="ff-sidebar__usuario text-truncate">{usuario?.nome}</div>
          <div className="ff-sidebar__email text-truncate">{usuario?.email}</div>
          <button
            type="button"
            className="ff-btn ff-btn--pequeno w-100 mt-2"
            style={{
              background: 'rgba(255,255,255,.12)',
              color: '#fff',
              borderColor: 'rgba(255,255,255,.2)',
            }}
            onClick={logout}
          >
            <i className="bi bi-box-arrow-right" aria-hidden="true" />
            Sair
          </button>
        </div>
      </aside>

      <div className="ff-conteudo">
        <header className="ff-topbar">
          <button
            type="button"
            className="ff-btn ff-btn--secundario ff-btn--pequeno"
            onClick={() => setAberta((v) => !v)}
            aria-label="Abrir menu"
            aria-expanded={aberta}
          >
            <i className="bi bi-list" aria-hidden="true" />
          </button>
          <Marca tamanho={22} sobre="claro" />
          <strong style={{ letterSpacing: '-0.02em' }}>FluxFin</strong>
        </header>

        <main className="ff-main">{children}</main>
      </div>
    </div>
  );
}
